import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import { RESOURCE_TYPE } from "@constants"
import { resourceType} from "@signals"


const OPTIONS = [
    { label: "Slider", value: RESOURCE_TYPE.SLIDER },
    { label: "Banner", value: RESOURCE_TYPE.BANNER },
    { label: "Product Slider", value: RESOURCE_TYPE.PRODUCT_SLIDER }
]

export default function ResourceTypeSelect({ ...props }) {
    return <SelectSeeker
        multiple
        isClearable
        options={OPTIONS}
        label="Image Types"
        value={resourceType.value}
        placeholder="All image types"
        onChange={e => resourceType.value = e.target.value}
        {...props}
    />
}